import script from "./InboundMailListingPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./InboundMailListingPanel.vue?vue&type=script&lang=ts&setup=true"

import "./InboundMailListingPanel.vue?vue&type=style&index=0&id=e59628f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59628f4"]])

export default __exports__